import React, { PropTypes } from 'react';
import { FlatButton, FontIcon } from 'material-ui';
import FileDownloadIcon from 'material-ui/svg-icons/file/file-download';
import AddToContractIcon from 'material-ui/svg-icons/content/add';
import EyeIcon from 'material-ui/svg-icons/image/remove-red-eye';
import R from 'ramda';
import A from 'aphrodite';


const Widgets = ({ addedToContractId, downloadFn, addToContractFn, hide, addedToCurrentContract, inContractThread, allowFilesToBeAddedToContract }, { router }) => {
  const styleSheets = A.StyleSheet.create({
    container: { display: hide ? 'none' : 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '4px' },
    'flex-tc-sb': { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  });

  return (
    <div className={A.css(styleSheets.container)}>
      {
        R.call(R.cond([
          [() => inContractThread && addedToCurrentContract, R.always(<div className={A.css(styleSheets['flex-tc-sb'])}>
            <FontIcon className="tc-icon-check" color="green"/>
            <span style={{ color: 'green', paddingRight: '8px' }}>Added</span>
          </div>)],
          [() => !inContractThread && addedToContractId, R.always(
            <FlatButton
              style={{ border: `1px solid green`, height: '30px', lineHeight: '30px', minWidth: '130px' }}
              onTouchTap={() => router.push(`/contracting/contract/${addedToContractId}/details`)}
            >
              <div className={A.css(styleSheets['flex-tc-sb'])} style={{ paddingLeft: '4px' }}>
                <EyeIcon color="green" style={{ marginLeft: '0px', width: '20px', height: '20px' }}/>
                <span style={{ textTransform: 'none', color: 'green', padding: '0 4px' }}>View Contract</span>
              </div>
            </FlatButton>
          )],
          [() => allowFilesToBeAddedToContract, R.always(
            <FlatButton
              style={{ border: `1px solid #49708A`, height: '30px', lineHeight: '30px', minWidth: inContractThread ? '167px' : '137px' }}
              onTouchTap={addToContractFn}
            >
              <div className={A.css(styleSheets['flex-tc-sb'])}>
                <AddToContractIcon color="#49708A" style={{ marginLeft: '0px' }}/>
                <span style={{ textTransform: 'none', color: '#49708A', padding: '0 4px' }}>
                  {inContractThread ? 'Add to This Contract' : 'Add to Contract'}
                </span>
              </div>
            </FlatButton>
          )],
        ]))
      }
      <FlatButton
        icon={<FileDownloadIcon color="#49708A" style={{ marginLeft: '0px' }}/>}
        style={{ border: '1px solid #49708A', marginLeft: '4px', height: '30px', lineHeight: '30px', minWidth: '40px' }}
        label=""
        labelStyle={{ textTransform: 'none', color: '#49708A', padding: '4px', verticalAlign: '', top: '-1px' }}
        onTouchTap={downloadFn}
      />
    </div>
  );
};

Widgets.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default Widgets;



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/attachmentActionWidgets.jsx